import api from '@/helpers/api'

const API_READ = `/api/client/dashboard`

export default {
    namespaced: true,
    state: {
        status: '',
        dashboard: [],
        errMessage: '',
        filter: {}
    },
    mutations: {
        request(state) {
            state.status = "Loading"
        },
        success(state) {
            state.status = "Success"
        },
        error(state, { message }) {
            state.status = "Error",
                state.errMessage = message
        },
        read(state, { dashboard }) {
            state.dashboard = { ...dashboard }
        },
        add_filter(state, { filter }) {
            state.filter = filter
        }
    },
    actions: {
        read({ commit, state }) {
            commit('request');

            const { meta } = state
            const { filter } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter })
                    .then((result) => {
                        commit('success');
                        commit('read', { dashboard: result.data.data });
                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        }
    },
    getters: {
        dashboard: () => (state) => state.dashboard
    }
}